export function resolveFirebaseMessagingPayloadLink(payload, windowRef = window) {
  return (
    payload?.fcmOptions?.link ||
    payload?.data?.link ||
    payload?.data?.url ||
    payload?.notification?.click_action ||
    windowRef?.location?.origin ||
    "/"
  );
}

export function attachForegroundMessageHandler(
  messaging,
  {
    onMessage,
    windowRef = typeof window !== "undefined" ? window : undefined,
    NotificationCtor = typeof Notification !== "undefined" ? Notification : undefined,
    logger = console,
  } = {}
) {
  if (!messaging || typeof onMessage !== "function") return;

  onMessage(messaging, (payload) => {
    logger.log?.("payload", payload);
    const title = payload?.data?.title || payload?.notification?.title || "New Message";
    const body = payload?.data?.body || payload?.notification?.body || "";
    const link = resolveFirebaseMessagingPayloadLink(payload, windowRef);

    if (!NotificationCtor || NotificationCtor.permission !== "granted") return;

    const notification = new NotificationCtor(title, {
      body,
      icon: "/logo192.png",
      tag: payload.messageId,
      data: {
        url: new URL(link, windowRef?.location?.origin).href,
      },
    });

    notification.onclick = function(event) {
      event.preventDefault();

      const urlToOpen = this?.data?.url || link;
      if (!urlToOpen) return;

      const resolved = new URL(urlToOpen, windowRef?.location?.origin).href;
      const target = new URL(resolved);
      const sameOrigin = target.origin === windowRef?.location?.origin;
      if (sameOrigin) {
        windowRef?.location?.assign(resolved);
      } else {
        windowRef?.open?.(resolved, "_blank");
      }

      this.close();
    };
  });
}

export async function initializeFirebaseMessaging({
  app,
  isSupported,
  getMessaging,
  onMessage,
  logger = console,
  windowRef = typeof window !== "undefined" ? window : undefined,
  NotificationCtor = typeof Notification !== "undefined" ? Notification : undefined,
} = {}) {
  try {
    const supported = typeof isSupported === "function" ? await isSupported() : false;
    if (!supported) return undefined;

    const messaging = getMessaging(app);
    attachForegroundMessageHandler(messaging, {
      onMessage,
      windowRef,
      NotificationCtor,
      logger,
    });
    return messaging;
  } catch (error) {
    logger.warn?.("Firebase messaging not supported in this environment", error);
    return undefined;
  }
}
